import { render, staticRenderFns } from "./CleanWordEditor.vue?vue&type=template&id=2359675d&"
import script from "./CleanWordEditor.vue?vue&type=script&lang=ts&"
export * from "./CleanWordEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports